import { useQuery } from "@tanstack/react-query";

import {
  getPricesCategories,
  type PriceCategoryListSortColumn,
  type SortOrder,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PRICE_CATEGORIES_QUERY_KEYS } from "./queryKeys";

interface UsePriceCategoriesListQueryParams {
  offset?: number;
  limit?: number;
  searchQuery?: string;
  sortBy?: PriceCategoryListSortColumn;
  sortOrder?: SortOrder;
}

export function usePriceCategoriesListQuery(
  params?: UsePriceCategoriesListQueryParams,
) {
  const { offset, limit, searchQuery, sortBy, sortOrder } = params ?? {};

  return useQuery({
    queryKey: PRICE_CATEGORIES_QUERY_KEYS.list(
      offset,
      limit,
      searchQuery,
      sortBy,
      sortOrder,
    ),
    queryFn: processResponse(() =>
      getPricesCategories(offset, limit, searchQuery, sortBy, sortOrder),
    ),
  });
}
